import appInfo from './app-info';
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { SingleCard } from './layouts';
import CrmLoginLayout from './layouts/CrmLoginLayout';
import { LoginForm, ResetPasswordForm, ChangePasswordForm, CreateAccountForm } from './components';
import GuestSignPage from './pages/GuestSignPage';
import Dict from './messages';

// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  return (
    <Switch>
      <Route exact path='/guest-sign/:token'>
        <SingleCard title={Dict.get('Doküman İmzalama')} showHeader={false}>
          <GuestSignPage />
        </SingleCard>
      </Route>
      <Route exact path='/login' >
        <CrmLoginLayout>
          <LoginForm />
        </CrmLoginLayout>
      </Route>
      <Route exact path='/create-account' >
        <SingleCard title={Dict.get('Kaydol')} showHeader={false}>
          <CreateAccountForm />
        </SingleCard>
      </Route>
      <Route exact path='/reset-password' >
        <SingleCard
          title={Dict.get('Şifreyi Sıfırla')}
          description="Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
          showHeader={false}
        >
          <ResetPasswordForm />
        </SingleCard>
      </Route>
      <Route exact path='/change-password/:recoveryCode' >
        <SingleCard title={Dict.get('Şifreyi Değiştir')} showHeader={false}>
          <ChangePasswordForm />
        </SingleCard>
      </Route>
      <Redirect to={'/login'} />
    </Switch>
  );
}
